/* eslint-disable no-console, @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { useCallback, useRef } from 'react';
import { deprecatedMsg } from './deprecatedMsg.js';

export const useSetRef = (initial: unknown) => {
  console.warn(`useSetRef ${deprecatedMsg}`);
  const ref = useRef(initial);
  const setRef = useCallback((node) => {
    ref.current = node;
  }, []);
  return [ref, setRef];
};
